import React from "react";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@material-ui/core";
import { makeStyles, withStyles } from "@material-ui/core/styles";

export const TblBodyCell = withStyles((theme) => ({
  head: {
    backgroundColor: "rgba(255, 255, 255, 1)",
    color: "rgba(107, 114, 128, 1)",
    fontSize: "12px",
    lineHeight: "16px",
    fontWeight: 500,
  },
  body: {
    fontSize: 14,
    background: "none",
  },
}))(TableCell);

const useStyles = makeStyles({
  table: {
    "& tr.selected td": {
      backgroundColor: "#eee",
      color: "black",
      fontWeight: 500,
    },
  },
  title: {
    fontSize: "1.828em",
    lineHeight: "1.5em",
    letterSpacing: "0.05625px",
    color: "rgba(63, 69, 79, 1)",
    margin: 0,
    marginBottom: "0.625em",
    fontWeight: 600,
  },
});

export const TblHead = TableHead;
export const TblHeadRow = TableRow;
export const TblHeadCell = TblBodyCell;
export const TblBody = TableBody;
export const TblBodyRow = withStyles((theme) => ({
  root: {},
}))(TableRow);

export const Tbl = (
  props: React.PropsWithChildren<{
    width?: string;
    maxHeight?: string;
    className?: string;
  }>
) => {
  const classes = useStyles();
  return (
    <TableContainer
      // component={Paper}
      style={{ width: props.width, maxHeight: props.maxHeight }}
      className={props.className}
    >
      <Table
        stickyHeader
        style={{ tableLayout: "auto", width: "100%" }}
        className={classes.table}
        aria-label="customized table"
      >
        {props.children}
      </Table>
    </TableContainer>
  );
};
